import { useState, useEffect } from "react";

const useIsMobile = (maxMobileWidth = 768) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < maxMobileWidth);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < maxMobileWidth);
    };

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [maxMobileWidth]);

  return isMobile;
};

export default useIsMobile;
